export const thousandAbbreviation = (numberToFormat: number) => {
  if (numberToFormat < 1000) return numberToFormat
  const abbreviatedNumber = (numberToFormat / 1000).toFixed(1)
  const [integer, decimal] = abbreviatedNumber.split('.')
  return `${decimal === '0' ? integer : abbreviatedNumber}k`
}
